import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import newsList from '@/components/newsList'
import newsDetail from '@/components/newsDetail'
import presentationDetail from '@/components/presentationDetail'
import paperDetail from '@/components/paperDetail'
import expertiseDetail from '@/components/expertiseDetail'
import lawDetail from '@/components/lawDetail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/newsList',
      name: 'newsList',
      component: newsList
    },
    {
      path: '/newsDetail',
      name: 'newsDetail',
      component: newsDetail
    },
    {
      path: '/presentationDetail/:presentation',
      name: 'presentationDetail',
      component: presentationDetail,
      props: true
    },
    {
      path: '/paperDetail',
      name: 'paperDetail',
      component: paperDetail,
      props: true
    },
    {
      path: '/expertiseDetail',
      name: 'expertiseDetail',
      component: expertiseDetail,
      props: true
    },
    {
      path: '/lawDetail',
      name: 'lawDetail',
      component: lawDetail,
      props: true
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js